import React, { Component } from 'react';
import { Data } from '../Data';

export class VerifyResetPassword extends Component {
    
    constructor(props) {
        super(props);
        this.dataService = new Data();
        this.postVerifyResetPassword = this.postVerifyResetPassword.bind(this);      
		this.buildQuestionOptions = this.buildQuestionOptions.bind(this);		
        this.state = {
            question1: '',
            questiontext1: '',
			answer1: '',
			question2:'',
			answer2: '',
			question3: '',
			answer3: '',
            questions: [],
            submitted: false,
            message: '',
            username: '- Not Found -'
        };

        this.handleChange = this.handleChange.bind(this);
        this.verifySsnIDExists();
        this.buildQuestionOptions();
    }
    verifySsnIDExists() {
        const ssnid = sessionStorage.getItem('SsnId');
        if (!ssnid) {
            window.location = '/login'
        }
    }

    handleChange(e) {
            const { name, value } = e.target;
            this.setState({ [name]: value });
    }

    postVerifyResetPassword(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { answer1, answer2, answer3, question1, question2, question3 } = this.state;
        if (answer1 && answer2 && answer3 && question1 && question2 && question3) {
            this.dataService.postVerifyResetPassword(answer1, answer2, answer3, question1, question2, question3)
                .catch(() => {
                    this.setState({ message: "Answer(s) to one or more of your security questions were incorrect.  Please try again." });
                });
        }
    }
	
    buildQuestionOptions() {
        Promise.all([
            this.dataService.getQuestions(sessionStorage.getItem('SsnId'))]
        ).then((data) => {
                this.setState({
                    questions: data[0].questions,
                    question1: data[0].questions.question1Id,
                    questiontext1: data[0].questions.question1,
                    question2: data[0].questions.question2Id,
                    questiontext2: data[0].questions.question2,
                    question3: data[0].questions.question3Id,
                    questiontext3: data[0].questions.question3,
                    username: data[0].username
                });
            });
    }

    render() {
        const { answer1, answer2, answer3, submitted, message } = this.state;

        return (
            <div>
                <div className="login-form-banner">
                    <h4>Username</h4>
                    <div>{this.state.username}</div>
                </div>
                <h4>Security Questions</h4>
                <form name="form" onSubmit={this.postVerifyResetPassword}>
                    <div className='login-form-container'>
					    <div className={'form-group' + (submitted && !answer1 ? ' has-error' : '')}>
                            <div className="login-form-label">{this.state.questiontext1}</div>
                            <input
                                type="text" 
                                className="form-control login-form-text"
                                name="answer1"
                                value={answer1}
                                onChange={this.handleChange}
                                title="Answer 1 text box"
                            />
                            {submitted && !answer1 &&
                                <div className="help-block">Answer to question 1 is required</div>
                            }
                        </div>
					
					    <div className={'form-group' + (submitted && !answer2 ? ' has-error' : '')}>
                            <div className="login-form-label">{this.state.questiontext2}</div>
                            <input
                                type="text"
                                className="form-control login-form-text"
                                name="answer2"
                                value={answer2}
                                onChange={this.handleChange}
                                title="Answer 2 text box"
                            />
                            {submitted && !answer2 &&
                                <div className="help-block">Answer to question 2 is required</div>
                            }
                        </div>
					
					    <div className={'form-group' + (submitted && !answer3 ? ' has-error' : '')}>
                            <div className="login-form-label">{this.state.questiontext3}</div>
                            <input
                                type="text"
                                className="form-control login-form-text"
                                name="answer3"
                                value={answer3}
                                onChange={this.handleChange}
                                title="Answer 3 text box"
                            />
                            {submitted && !answer3 &&
                                <div className="help-block">Answer to question 3 is required</div>
                            }
                        </div>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary login-button" title="Reset password button">Reset Password</button>
                        <a href="/Login" title="Link to cancel password reset">Cancel</a>
                    </div>
                </form>
                {message && <div className="help-block">{message}</div>}
            </div>
        );
    }
}
